import React from "react";
import { Currency } from "../../../js/common/CurrencyFormatter";
import { BasketPageCheckoutOrderModel, CheckoutOrderViewAccessory, EshopAccessory } from "./checkoutOrderView";
import OfferEshopAccessoryItem from "./OfferEshopAccessoryItem";
import { useChangeOrderAccessoryMutation, useChangeOrderAccessoryPriceMutation } from "./basketHooks";

interface OfferOrderAccessoriesBlockProperties {
    readonly eshopAccessories: EshopAccessory[];
    readonly orderAccessories: CheckoutOrderViewAccessory[];
    readonly onModelChange: (model: BasketPageCheckoutOrderModel) => void;
    readonly currency: Currency;
}

export default function OfferEshopAccessoriesBlock({
    eshopAccessories,
    orderAccessories,
    onModelChange,
    currency,
}: OfferOrderAccessoriesBlockProperties): React.JSX.Element {
    const changeOrderAccessoryMutation = useChangeOrderAccessoryMutation(onModelChange);
    const changeOrderAccessoryPriceMutation = useChangeOrderAccessoryPriceMutation(onModelChange);

    const eshopAccessoriesItems = [];
    const thankYouMessageItems = [];

    const handleAccessoryChange = (eshopAccessory: EshopAccessory, isSelected: boolean): void => {
        changeOrderAccessoryMutation.mutate({
            eshopAccessoryId: eshopAccessory.id,
            isSelected: isSelected,
        });
    };

    const handleAccessoryPriceChange = (eshopAccessory: EshopAccessory, price: number): void => {
        changeOrderAccessoryPriceMutation.mutate({
            eshopAccessoryId: eshopAccessory.id,
            price: price,
        });
    };

    for (const eshopAccessory of eshopAccessories) {
        const orderAccessory = orderAccessories.find((item) => item.eshopAccessoryId === eshopAccessory.id);

        eshopAccessoriesItems.push(
            <OfferEshopAccessoryItem
                eshopAccessory={eshopAccessory}
                key={eshopAccessory.id}
                price={orderAccessory !== undefined ? orderAccessory.price : eshopAccessory.price}
                isSelected={orderAccessory !== undefined}
                onChange={handleAccessoryChange}
                onPriceChange={handleAccessoryPriceChange}
                currency={currency}
            />,
        );

        if (orderAccessory !== undefined) {
            thankYouMessageItems.push(<li key={eshopAccessory.id}><i
                className="fa-solid fa-circle-info">
            </i>{eshopAccessory.thankYouMessage}
            </li>);
        }
    }

    return (
        <div className="cart-accessory-block">
            <h1><i className="fa-solid fa-plus"></i> Něco navíc</h1>
            <ul>{eshopAccessoriesItems}</ul>

            {thankYouMessageItems.length > 0
              && <ul className="accessory-description-detail">{thankYouMessageItems}</ul>}
        </div>
    );
}
